export default __webpack_public_path__ + "static/media/sc28.02f3f42f.jpg";